export const Colors = {
    colors: {
        colorPrimary0: "#000000",
        colorPrimary50: "#1A1A1A",
        colorPrimary100: "#333333",
        colorPrimary200: "#333333",
        colorPrimary300: "#666666",
        colorPrimary400: "#808080",
        colorPrimary500: "#1A1A1A",
        colorPrimary600: "#585858",
        colorPrimary700: "#CCCCCC",
        colorPrimary800: "#E5E5E5",
        colorPrimary1000: "#000000",

        colorIcons: "#000000",
        colorText: "#000000",
        colorBtnText: "#FFFFFF",
        colorHover: "#000000",
        colorMutedText: "#0000008a",
        colorOn: "#5c5c5c",
        colorContrast: "#000000",
        colorTextReverse: "#FFFFFF",
        colorOff: "#b7b7b7",
        colorPositive: "#000000",
        colorNegative: "#000000",
        colorDndText: "#000000",
        colorMenu: "#b2b2b2",

        colorStatusError: "#000000",
        colorStatusTrue: "#000000",
        colorStatusInfo: "#000000",
        colorStatusWarning: "#000000",
        colorBarError: "#ffffff",
        colorBarWarning: "#000000",
        colorBarProgress: "#000000",

        colorProgress20: "#000000",
        colorProgress40: "#000000",
        colorProgress60: "#000000",
        colorProgress80: "#000000",
        colorProgress100: "#000000",
        colorProgress120: "#000000",

        colorBlue100: "#000000",
        colorBlue200: "#000000",
        colorBlue300: "#000000",
        colorBlue1000: "#000000",

        colorPurple: "#800080", 
        colorPink: "#FFC0CB",
        colorWhite: "#FFFFFF",
    },
}